var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath24462(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4523 25.9592L35.6759 27.2934C36.1138 27.5563 36.2558 28.1243 35.9932 28.5624C35.9149 28.6924 35.806 28.8013 35.6759 28.8796L19.4517 38.614C18.8658 38.9654 18.1341 38.9654 17.5482 38.614L1.32418 28.8796C0.886175 28.6167 0.744132 28.0487 1.00695 27.6107C1.08504 27.4804 1.19399 27.3715 1.32418 27.2934L3.54776 25.9592L18.5 34.9305L33.4523 25.9592ZM33.4523 17.2653L35.6759 18.5995C36.1138 18.8624 36.2558 19.4304 35.9932 19.8685C35.9149 19.9985 35.806 20.1075 35.6759 20.1857L18.5 30.4911L1.32418 20.1857C0.886175 19.9229 0.744132 19.3548 1.00695 18.9168C1.08504 18.7865 1.19399 18.6776 1.32418 18.5995L3.54776 17.2653L18.5 26.2366L33.4523 17.2653ZM19.4517 0.263605L35.6759 9.99809C36.1138 10.2609 36.2558 10.829 35.9932 11.267C35.9149 11.3972 35.806 11.5062 35.6759 11.5842L18.5 21.8897L1.32418 11.5842C0.886175 11.3215 0.744132 10.7533 1.00695 10.3153C1.08504 10.1851 1.19399 10.0762 1.32418 9.99809L17.5482 0.263605C18.1341 -0.0878683 18.8658 -0.0878683 19.4517 0.263605ZM18.5 4.00695L7.19296 10.7912L18.5 17.5753L29.807 10.7912L18.5 4.00695Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath24462);
export default __webpack_public_path__ + "static/media/Path 24462.cf85e562ffdbff9eeb52c075f062b5d3.svg";
export { ForwardRef as ReactComponent };